import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { canAccessOrganizerBlocks } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { defaultAdminHome } from '../../../features/auth/default-admin-home';

export const Route = createFileRoute('/_authenticated/organizer-blocks')({
  staticData: { breadcrumb: 'Блокировки организаторов' },
  component: OrganizerBlocksGuard,
});

function OrganizerBlocksGuard() {
  const { adminRoles } = useAuth();
  if (!canAccessOrganizerBlocks(adminRoles)) {
    return <Navigate to={defaultAdminHome(adminRoles)} />;
  }
  return <Outlet />;
}
